package com.eladfinish.bible.contest.utils

import com.eladfinish.bible.contest.common.usecases.RemoveTeamimUseCase
import com.eladfinish.bible.contest.constants.StringConstants.MAKAF
import com.eladfinish.bible.contest.constants.StringConstants.Regex.ALEF_TAV
import com.eladfinish.bible.contest.constants.StringConstants.Regex.ALEF_TAV_
import com.eladfinish.bible.contest.constants.StringConstants.Regex.WORD_CHAR
import com.eladfinish.bible.contest.extensions.asInnerRegex
import com.eladfinish.bible.contest.extensions.end
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.extensions.start
import com.eladfinish.bible.contest.utils.MyStringUtils.getAlefTavExcluding
import com.eladfinish.bible.contest.utils.MyStringUtils.qMark

fun String.withVavAndYud(): String =
    this.withVav().withYud()

fun String.withVav(): String {
    var word = this
    val vav = 'ו'
    val qamatz = 'ָ'
    val patach = 'ַ'
    val chatafQamatz = 'ֳ'
    val shva = 'ְ'
    val dagesh = 'ּ'
    val cholam = 'ֹ'
    val qubutz = 'ֻ'
    val gerish = '֝' // char meteg = 'ֽ';
    val otiot = "[$ALEF_TAV_]"
    val notAlefTavSpace = "[^$ALEF_TAV_]"
    val shin = "ש"
    val shinSemalit = "שׂ"
    val shinYemanit = "שׁ"

    word = word.replaceRegex(
        regex = "$shinSemalit|$shinYemanit",
        replacement = shin
    )

    //add vav if there is qamatz katan followed by dagesh chazak               //check below
    val regex = "($otiot$dagesh?$qamatz)($otiot$dagesh$notAlefTavSpace{0,2}$otiot)".toRegex()
    var str = word
    var vavCounter = -1
    regex.findAll(word).forEach {
        val group0 = it.groups[0]?.value
        val group1 = it.groups[1]?.value
        val group2 = it.groups[2]?.value
        val start = it.start
        val end = it.end
        if ("בּ?ָתּ".toRegex().find(group0.toString()) == null) {
            val startIndex = start + ++vavCounter
            val endIndex = end + vavCounter
            val replacement = group1!! + vav + qMark + group2
            str = str.replaceRange(startIndex until endIndex, replacement) //insert vav after qamatz katan
        }
    }

    word = str

    //add vav if there is qamatz katan followed by shva nach: "veyehu asa beoqba"
    word = word.replaceRegex(
        regex = "($otiot$dagesh?$qamatz$gerish?)($otiot$shva)",
        replacement = "$1$vav$qMark$2"
    )

    //add vav if there is word ends with qamatz katan followed by makaf
    word = word.replaceRegex(
        regex = "($qamatz)($otiot$MAKAF)",
        replacement = "$1$vav$qMark$2"
    )

    //remove teamim from the word
    val removeTeamimUseCase = RemoveTeamimUseCase()
    word = removeTeamimUseCase(word)

    //add vav if there are two consecutive qamatz in verb which start with vav: "vayaqom, vayamol"
    word = word.replaceRegex(
        regex = "($vav$patach$otiot$dagesh$qamatz$otiot$qamatz)",
        replacement = "$1$vav$qMark"
    )

    //add vav if there is chataf qamatz
    word = word.replaceRegex(
        regex = "($otiot$dagesh?$chatafQamatz)",
        replacement = "$1$vav$qMark"
    )

    //add vav if it is vowel or it has dagesh
    word = word.replaceRegex(
        //"(" + dagesh + "?[^\\?" + ALEF_TAV_ + dagesh + cholam + qubutz + makaf + "\\s])",
        regex = "(\\S$vav)($dagesh?[^?$ALEF_TAV_$dagesh$cholam$qubutz$MAKAF\\s])",
        replacement = "$1$vav$qMark$2"
    )

    //add vav if there is cholam chasser on non-vav letter
    word = word.replaceRegex(
        regex = "([^$vav])($cholam)",
        replacement = "$1$vav$qMark$2"
    )

    //add vav if there is cholam chasser on vav letter
    word = word.replaceRegex(
        regex = "($otiot?[^$ALEF_TAV_$dagesh]$vav)($cholam)",
        replacement = "$1$vav$qMark$2"
    )

    //add vav if there is kubutz
    word = word.replaceRegex(
        regex = "($qubutz)([^$vav])",
        replacement = "$1$vav$qMark$2"
    )
    return word
}

fun String.withYud(): String {
    var word = this
    val yud = 'י'
    val vav = 'ו'
    val qamatz = 'ָ'
    val hafSofit = 'ך'
    val nunSofit = 'ן'
    val chirik = 'ִ'
    val dagesh = 'ּ'
    val shva = 'ְ'
    val tzere = 'ֵ'
    val removeTeamimUseCase = RemoveTeamimUseCase()
    word = removeTeamimUseCase(word)
    //        String shin = "ש", shin_semalit = "שׂ", shin_yemanit = "שׁ";
    val shin = "ש"
    val shinSemalit = "שּ?ׂ"
    val shinYemanit = "שּ?ׁ" //optional dagesh in shin
    word = word.replaceRegex(
        regex = "$shinSemalit|$shinYemanit",
        replacement = shin
    )
    word = word.replaceRegex(
        regex = "$hafSofit$shva",
        replacement = "" + hafSofit
    )

    //add yud if there is chirik chasser
    if (!word.matches("הִוא".asInnerRegex())) {
        word = word.replaceRegex(
            // (?!WORD_CHAR) rather than \b: JS RegExp's \b is ASCII-only (see WORD_CHAR)
            regex = ("(" + chirik + ")" + "(" + getAlefTavExcluding(yud) + "([^" + shva + "]|(?!$WORD_CHAR)))"),
            replacement = "$1$yud$qMark$2"
        )
    }
    //                    + "([^" + shva + dagesh + "]|\\b))", "$1" + yud + qMark + "$2");
    // ^ don't add yud after Mipney, Gilboa etc.

    //add yud if there is chirik chasser followed by yud with dagesh: Moriah -> Moriiah
    word = word.replaceRegex(
        regex = "($chirik)($yud$dagesh[^$ALEF_TAV_\\s])",
        replacement = "$1$yud$qMark$2"
    )

    //add yud if there is a yud which has tzere: Shena -> Sheina
    word = word.replaceRegex(
        regex = "($yud$dagesh?$tzere)",
        replacement = "$1$yud$qMark"
    )

    //add yud if there is qamatz followed by vav at the end of the word: Esav -> Esaiv
    word = word.replaceRegex(
        regex = "($qamatz)($vav$)",
        replacement = "$1$yud$qMark$2"
    )

    // add yud after shva + yud + qamatz when another Hebrew letter follows (e.g., קִנְיָנוֹ, רַעְיָתִי, מַעְיָן)
    // NOTE: use ALEF_TAV_ (the bare "א-ת" range, no brackets) here, not ALEF_TAV (which is
    // already wrapped as "[א-ת]") — nesting a bracketed class inside another character class
    // (e.g. "[[א-ת]ךן]") is invalid under JS's unicode-mode RegExp ("Lone quantifier brackets"),
    // even though Kotlin/JVM's regex engine tolerates it.
    word = word.replaceRegex(
        regex = "($shva)($yud$qamatz)([$ALEF_TAV_$hafSofit$nunSofit])",
        replacement = "$1$2$yud$qMark$3",
    )
    return word
}
